<template>
  <v-dialog
    class="tile"
    v-model="dialogDireccion"
    max-width="600"
    scrollable
    :fullscreen="$vuetify.breakpoint.xs"
    :persistent="loadingDialog"
  >
    <v-card>
      <v-card-title class="flex py-4 white">
        <!-- Botones superiores del modal -->
        <span
          class=" text-center font-weight-bold mx-auto"
        >{{ $t('pedido.Direccion.dialog.titulo.midireccion') }}</span>
        <v-btn
          class="ml-auto"
          width="36"
          height="36"
          elevation="3"
          icon
          color="#ffffff"
          style="background-color:white;"
          absolute
          right
          small
          top
          :disabled="loadingDialog"
          @click="dialogDireccion=false"
        >
          <v-icon class="black--text ma-auto">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-divider></v-divider>

      <v-card-text class="px-2">
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col class cols="9" sm="9">
              <v-text-field
                @input="cambiarDireccion"
                :disabled="loadingDialog"
                v-model="dirDomicilioDialogo.calle"
                :rules="rulescalle"
                :label="$t('pedido.Direccion.dialog.textField1.label.calle')"
                v-on:keyup.enter="enter"
                required
              ></v-text-field>
            </v-col>
            <v-col class="px-2" cols="3" sm="3">
              <v-text-field
                :disabled="loadingDialog"
                v-model="dirDomicilioDialogo.numero"
                :label="$t('pedido.Direccion.dialog.textField2.label.numero')"
                v-on:keyup.enter="enter"
              ></v-text-field>
            </v-col>
            <v-col class="px-2" cols="8" sm="9">
              <v-text-field
                :disabled="loadingDialog"
                v-model="dirDomicilioDialogo.adicional"
                :label="$t('pedido.Direccion.dialog.textField3.label.bloque')"
                v-on:keyup.enter="enter"
              ></v-text-field>
            </v-col>
            <v-col class="px-2" cols="4" sm="3">
              <v-text-field
                @input="cambiarDireccion"
                :disabled="loadingDialog"
                v-model="dirDomicilioDialogo.cp"
                :rules="rulescp"
                :label="$t('pedido.Direccion.dialog.textField4.label.cp')"
                v-on:keyup.enter="enter"
              ></v-text-field>
            </v-col>
            <v-col class="px-2" cols="6" sm="6">
              <v-combobox
                @input="cambiarDireccion"
                :disabled="loadingDialog"
                v-model="dirDomicilioDialogo.municipio"
                :rules="rulesmunicipio"
                :items="municipioAutocomplete"
                :label="$t('pedido.Direccion.dialog.textField5.label.municipio')"
                v-on:keyup.enter="enter"
              ></v-combobox>
            </v-col>
            <v-col class="px-2" cols="6" sm="6">
              <v-combobox
                @change="cambiarDireccion"
                :disabled="loadingDialog"
                v-model="dirDomicilioDialogo.provincia"
                :rules="rulesprovincia"
                :items="provinciasAutocomplete"
                :label="$t('pedido.Direccion.dialog.textField6.label.provincia')"
                v-on:keyup.enter="enter"
              ></v-combobox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="pa-0">
        <v-btn
          v-if="sinCambios"
          ref="botonConfirmar"
          class
          x-large
          tile
          block
          :disabled="invalidDirDialog"
          color="success"
          @click="dialogoTopedir"
        >{{ $t('pedido.Direccion.dialog.btn2.confirmar') }}</v-btn>
        <v-btn
          v-else
          ref="botonConfirmar"
          class
          x-large
          tile
          block
          :disabled="invalidDirDialog"
          color="info"
          @click="comprobarDireccionNuevamente"
        >Comprobar Nuevos Datos</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "dialogDireccion",
  data() {
    return {
      direccionInicial: {},
      v: true,
      rulescp: [
        v =>
          /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/.test(v) ||
          this.$t("pedido.Direccion.dialog.textField.error.formato")
      ],
      rulescalle: [
        v =>
          !!v || this.$t("pedido.Direccion.dialog.textField.error.campovacio")
      ],
      rulesmunicipio: [
        v =>
          !!v || this.$t("pedido.Direccion.dialog.textField.error.campovacio")
      ],
      rulesprovincia: [
        v =>
          !!v || this.$t("pedido.Direccion.dialog.textField.error.campovacio")
      ]
    };
  },
  computed: {
    dialogDireccion: {
      get() {
        console.log("aquiIIIIII");
        return this.$store.state.direcciones.dialogoDomicilioDireccion;
      },
      set(value) {
        this.$store.commit("direcciones/setDialogoDomicilioDireccion", value);
      }
    },
    sinCambios: {
      get() {
        return this.$store.state.direcciones.dirDomicilioDialogSinCambios;
      },
      set(val) {
        this.$store.commit("direcciones/setDirDomicilioDialogSinCambios");
      }
    },
    invalidDirDialog() {
      return (
        this.loadingDialog ||
        this.dirDomicilioDialogo.provincia == "" ||
        this.dirDomicilioDialogo.municipio == "" ||
        this.dirDomicilioDialogo.calle == "" ||
        this.dirDomicilioDialogo.cp == ""
      );
    },
    ...mapState({
      windowOrientation: state => state.app.windowOrientation,
      listadoRestaurantes: state => state.restaurante.restaurantesPosibles,
      isTablet: state => state.app.isTablet,
      isMobile: state => state.app.isMobile,
      direccionPedido: state => state.pedido.direccionPedido,
      dirDomicilioDialogo: state => state.direcciones.dirDomicilioDialogo,
      provinciasAutocomplete: state => state.direcciones.provincias,
      paisAutocomplete: state => state.direcciones.pais,
      municipioAutocomplete: state => state.direcciones.municipios,
      coordenadas: state => state.pedido.addressObject.coordenadas,
      modoEditar: state => state.pedido.modoEditarDireccion,
      modoGeneral: state => state.app.modoGeneral
    }),
    loadingDialog: {
      get() {
        return this.$store.state.direcciones.loadingDialogDireccionDomicilio;
      },
      set(value) {
        this.$store.commit(
          "direcciones/setLoadingDialogDireccionDomicilio",
          value
        );
      }
    },
    calle: {
      get() {
        return this.dirDomicilioDialogo.calle;
      },
      set(value) {
        this.$store.commit("direcciones/setDirDomicilioDialogoPorTipo", [
          "calle",
          value
        ]);
      }
    },
    numero: {
      get() {
        return this.dirDomicilioDialogo.numero;
      },
      set(value) {
        this.$store.commit("direcciones/setDirDomicilioDialogoPorTipo", [
          "numero",
          value
        ]);
      }
    },
    adicional: {
      get() {
        return this.dirDomicilioDialogo.adicional;
      },
      set(value) {
        this.$store.commit("direcciones/setDirDomicilioDialogoPorTipo", [
          "adicional",
          value
        ]);
      }
    },
    cp: {
      get() {
        return this.dirDomicilioDialogo.cp;
      },
      set(value) {
        this.$store.commit("direcciones/setDirDomicilioDialogoPorTipo", [
          "cp",
          value
        ]);
      }
    },
    municipio: {
      get() {
        return this.dirDomicilioDialogo.municipio;
      },
      set(value) {
        this.$store.commit("direcciones/setDirDomicilioDialogoPorTipo", [
          "municipio",
          value
        ]);
      }
    },
    provincia: {
      get() {
        return this.dirDomicilioDialogo.provincia;
      },
      set(value) {
        this.$store.commit("pedido/setAddressObjectByType", [
          "provincia",
          value
        ]);
      }
    },
    pais: {
      get() {
        return this.dirDomicilioDialogo.pais;
      },
      set(value) {
        this.$store.commit("pedido/setAddressObjectByType", ["pais", value]);
      }
    }
  },
  methods: {
    cambiarDireccion() {
      if (this.sinCambios) {
        this.$store.commit(
          "direcciones/setDirDomicilioDialogoOld",
          this.dirDomicilioDialogo
        );
        this.sinCambios = false;
      }
    },
    comprobarDireccionNuevamente(dir) {
      this.$store.dispatch("direcciones/comprobarDireccionNuevamente");
    },
    ...mapActions({
      elegirRestaurante: "pedido/elegirRestaurante",
      geocodeAddress: "direcciones/geocodeInput",
      loadAndOrderRestaurants: "direcciones/loadAndOrderRestaurants",
      pedirADireccion: "direcciones/pedirADireccion"
    }),
    dialogoTopedir() {
      this.$store.dispatch("direcciones/dialogoDireccionDomicilioToPedir");
    },

    validarDireccion_old() {
      let _vue = this;
      this.pais = "España";
      // this.loadingDialog = true;
      let reconstruccionDireccion =
        this.calle +
        " " +
        this.numero +
        " " +
        this.cp +
        " " +
        this.municipio +
        " " +
        this.pais;
      let noAddressChanges =
        this.addressObject.calle == this.direccionInicial.calle &&
        this.addressObject.cp == this.direccionInicial.cp &&
        this.addressObject.municipio == this.direccionInicial.municipio &&
        this.addressObject.provincia == this.direccionInicial.provincia;

      /*
       * Si no hay cambios "noAddressChanges" se manda a pedir directamente para no repetir llamada a google
       * si hay cambios si busca la direccion, si le falta algún campo necesario "camposVacios", se genera error
       * Si todo está correcto se manda a pedir
       */

      if (noAddressChanges) {
        // _vue.cargarRestaurantes();
        _vue.pedir(_vue.addressObject);
      } else {
        _vue.$store
          .dispatch("pedido/geocodeAddress", reconstruccionDireccion)
          .then(data => {
            let camposVacios =
              _vue.calle == "" ||
              _vue.cp == "" ||
              _vue.municipio == "" ||
              _vue.provincia == "";

            if (camposVacios) {
              _vue.$store.commit("snackbar/setMensajeDanger", {
                msj:
                  "No se localiza la dirección. Revise los campos o use la herramienta LOCALÍZAME"
              });
            } else {
              _vue.$store.commit("pedido/setAddressObjectSinFiltro", data);
              _vue.$store.commit("pedido/setNavigatorAddress", data.formated);
              _vue.pedir(data);
            }
          })
          .finally(() => {
            _vue.loadingDialog = false;
            _vue.dialogDireccion = false;
          });
      }
    },

    cargarRestaurantes() {
      console.log("cargar restaurantes");
      _vue
        .loadAndOrderRestaurants()
        // _vue.$store.dispatch("restaurante/getListadoRestNegMix")
        .then(data => {
          _vue.$store
            .dispatch("direcciones/comprobarDireccion")
            .then(function(res) {})
            .finally(function() {
              _vue.dialogDireccion = false;
              _vue.loadingDialog = false;
            });
        })
        .finally(function() {
          _vue.dialogDireccion = false;
          _vue.loadingDialog = false;
        });

      // }
    },
    enter() {
      const elem = this.$refs.botonConfirmar;
      if (!this.invalidDirDialog) {
        this.$refs.botonConfirmar.$el.click();
      }
    }
  },
  mounted() {},
  watch: {
    dialogDireccion(newV, oldV) {
      /*if (!newV) {
        this.$store.commit("pedido/setModoEditarDireccion", false);
        this.reiniciarValores();
      } else {
        this.direccionInicial.calle = this.dirDomicilioDialogo.calle;
        this.direccionInicial.numero = this.dirDomicilioDialogo.numero;
        this.direccionInicial.cp = this.dirDomicilioDialogo.cp;
        this.direccionInicial.adicional = this.dirDomicilioDialogo.adicional;
        this.direccionInicial.provincia = this.dirDomicilioDialogo.provincia;
        this.direccionInicial.municipio = this.dirDomicilioDialogo.municipio;
        this.direccionInicial.pais = this.dirDomicilioDialogo.pais;
      }*/
    }
  }
};
</script>

<style scoped>
.v-banner--is-mobile div.v-banner__wrapper {
  padding: 0px !important;
}
#productDialog .v-card__actions {
  position: sticky;
  bottom: 0px;
  background: white;
}
.p-absolute {
  position: absolute;
}
.p-sticky {
  position: sticky;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
}
.tile {
  border-radius: 0px;
}
.bottom {
  bottom: 0px;
}
.top {
  top: 0px;
}
.index-1 {
  z-index: 1;
}
.index-5 {
  z-index: 5;
}
.w-100 {
  width: 100%;
}
.mw-100 {
  max-width: 100%;
}
.vh-75 {
  height: 75vh;
}
.v-tabs:not(.v-tabs--vertical) .v-tab {
  white-space: nowrap;
  width: auto !important;
  text-transform: initial;
  color: rgba(0, 0, 0);
}
.v-dialog .v-card .v-card__actions {
  position: sticky;
  bottom: 0px;
}
/* Navbar categorias */
.card {
  background-color: #fff;
  min-width: 100%;
}
.card::-webkit-scrollbar {
  display: none;
}
.card--content {
  white-space: nowrap;
  width: auto !important;
  text-transform: initial;
  cursor: pointer;
}
.slider-wrapper {
  width: 100px;
  height: 2px;
  background-color: #4caf50;
  border: 1px solid #4caf50;
  position: absolute;
  bottom: 0px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #f6f6f6 !important;
}

.v-list-item--link::before {
  background-color: transparent !important;
}
</style>
